import { render, staticRenderFns } from "./PriorDetermination.vue?vue&type=template&id=0a60e017&"
import script from "./PriorDetermination.vue?vue&type=script&lang=js&"
export * from "./PriorDetermination.vue?vue&type=script&lang=js&"
import style0 from "./PriorDetermination.vue?vue&type=style&index=0&id=0a60e017&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports